export default __webpack_public_path__ + "static/media/nodejs.ceee4937.png";